/* eslint-disable no-param-reassign */

/**
 * Check or uncheck all filter options
 *
 * @param {Event} event
 * @param {Object} filters
 * @param {Object} variables
 */
export const checkAll = (event, filters, variables) => {
  if (event.target.checked) {
    variables.groups = filters.categories.map((c) => c.uri);
  } else {
    variables.groups = [];
  }
};

/**
 * Toggle filter option
 *
 * @param {String} handle
 * @param {Boolean} showSubfilter
 */
export const toggleFilter = (handle, showSubfilter) => {
  showSubfilter.val = showSubfilter.val === handle ? '' : handle;
};
